const gallery = (flexOne,flexTwo,flexThree) => {
    let array = [1,2,3,4,5,6,7,8,9,10,11,12,13,14,15];
    array.sort(function() { return Math.random() - 0.5;});
 
    document.querySelector(flexOne).innerHTML = `
        <img src="img/galery/galery${array[0]}.webp" alt="picture" class="gallery__img">
        <img src="img/galery/galery${array[1]}.webp" alt="picture" class="gallery__img">
        <img src="img/galery/galery${array[2]}.webp" alt="picture" class="gallery__img">
        <img src="img/galery/galery${array[3]}.webp" alt="picture" class="gallery__img">
        <img src="img/galery/galery${array[4]}.webp" alt="picture" class="gallery__img">
    `;

    document.querySelector(flexTwo).innerHTML = `
        <img src="img/galery/galery${array[5]}.webp" alt="picture" class="gallery__img">
        <img src="img/galery/galery${array[6]}.webp" alt="picture" class="gallery__img">
        <img src="img/galery/galery${array[7]}.webp" alt="picture" class="gallery__img">
        <img src="img/galery/galery${array[8]}.webp" alt="picture" class="gallery__img">
        <img src="img/galery/galery${array[9]}.webp" alt="picture" class="gallery__img">
    `;

    document.querySelector(flexThree).innerHTML = `
        <img src="img/galery/galery${array[10]}.webp" alt="picture" class="gallery__img">
        <img src="img/galery/galery${array[11]}.webp" alt="picture" class="gallery__img">
        <img src="img/galery/galery${array[12]}.webp" alt="picture" class="gallery__img">
        <img src="img/galery/galery${array[13]}.webp" alt="picture" class="gallery__img">
        <img src="img/galery/galery${array[14]}.webp" alt="picture" class="gallery__img">
    `;
};

export default gallery;